export const emptyAreaResponse = {
    "label": [],
    "rain": {
        "labels": [],
        "data": [
            {
                "data": [],
                "label": "ปริมาณน้ำฝน"
            },
            {
                "data": [],
                "label": "ค่าพยากรณ์น้ำฝน"
            }
        ]
    },
    "wl": {
        "labels": [],
        "data": [
            {
                "data": [],
                "label": "ระดับน้ำ",
                "type": "line",
                "borderColor": "#000f96"
            },
            {
                "data": [],
                "label": "ค่าพยากรณ์",
                "type": "line",
                "borderColor": "#960000"
            }
        ]
    },
    "soil1": {
        "labels": [],
        "data": [
            {
                "data": [],
                "label": "ความชื้น"
            },
            {
                "data": [],
                "label": "ค่าพยากรณ์ความชื้น"
            }
        ]
    },
    "soil2": {
        "labels": [],
        "data": [
            {
                "data": [],
                "label": "ความชื้น"
            },
            {
                "data": [],
                "label": "ค่าพยากรณ์ความชื้น"
            }
        ]
    },
    "temperature": {
        "labels": [ ],
        "data": [
            {
                "data": [],
                "label": "อุณหภูมิ"
            },
            {
                "data": [],
                "label": "ค่าพยากรณ์อุณหภูมิ"
            }
        ]
    },
    "date": null,
    "predictionWL": null,
    "flood_count": 0,
    "level": 0
  }
